import { FaqType } from "./types";

export const getFileExtension = (filename: string): string => {
  return filename.split(".").pop()?.toLowerCase() || "";
};

export const getFileIcon = (type: string): string => {
  if (!type) return "insert_drive_file";
  if (type === "pdf") return "picture_as_pdf";
  if (type === "docx" || type === "doc") return "description";
  if (type === "xlsx" || type === "xls") return "table_chart";
  if (["png", "jpg", "jpeg", "gif"].includes(type)) return "image";
  return "insert_drive_file";
};

export const getContentPreview = (content: string, limit = 20): string => {
  const text = content || "";
  return text.length > limit ? `${text.slice(0, limit)}...` : text;
};

export const getDisplayName = (attachment: string): string => {
  const fileName = attachment.split("/").pop() || attachment;
  return fileName.includes("_")
    ? fileName.substring(fileName.indexOf("_") + 1)
    : fileName;
};

export const mapApiToFaq = (item: any): FaqType => {
  const attachments =
    item.attachments || item.faqAttachments || item.faqFiles || [];

  const files = Array.isArray(attachments)
    ? attachments.map((attachment: string, index: number) => {
        const fileName = attachment.split("/").pop() || attachment;
        return {
          id: `f${index + 1}`,
          name: getDisplayName(attachment),
          size: "",
          type: getFileExtension(fileName),
          url: attachment,
        };
      })
    : undefined;

  return {
    id: String(item.faqId ?? item.id ?? crypto.randomUUID()),
    title: item.faqTitle ?? item.title ?? "",
    version: item.faqVersion ?? item.version ?? "",
    content: item.faqContent ?? item.content ?? "",
    files,
  };
};
